<div [ngClass]="borderClass">
	<div [ngClass]="containerClass">
		<ng-content></ng-content>
	</div>
</div>
